/*
 * @Author: your name
 * @Date: 2021-07-19 15:38:34
 * @LastEditTime: 2021-08-16 17:57:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\cms\index.js
 */
import request from "../request";
// var qs = require('qs');
// let baseUrl = request.getBaseUrl();
const server = {
  // fileUpload: `${baseUrl}/cms/cms/fileUpload`,
  //获取商品详情
  //  querySkuInfoById: function (params) {
  //   return request.fetch(`/product/skuManagement/querySkuInfoForOperator?${qs.stringify(params)}`)
  // },
  // 分页查询当前公司编制的发货单
  getCompanyLogisticsList: function(params) {
    return request.post("/logistics/logistics/getCompanyLogisticsList", params);
  },
  // 查询发货单详情
  getCompanyLogisticsDetail: function(params) {
    return request.post("/logistics/logistics/getCompanyLogisticsDetail", params);
  },
  // 导出当前公司的发货单
  exportCompanyLogistics: function(params) {
    return request.post("/logistics/logistics/exportCompanyLogistics", params, {
      responseType: "blob",
    });
  },
  // 发货页面 查询物流单
  queryLogisticsList: function(params) {
    return request.post("/logistics/ewuliu/queryLogisticsList", params,);
  },
  // 获取司机和车辆  自配
  getDrivers(params) {
    return request.post('logistics/ewuliu/getDrivers', params);
  },
  // 获取本地物流商
  getLocalTenantList(params) {
    return request.post('logistics/ewuliu/getLocalTenantList', params);
  },
  // 获取本地物流商
  queryShipInquiryCarType(params) {
    return request.post('transaction-center/orderConfig/queryShipInquiryCarType', params);
  },
  // 查询全部物流商
  selectAllTransport(params) {
    return request.post('user-center/companyTransport/selectAll', params);
  },

 
}
export default server
